import { unifiedApi } from '../httpService';


const getRatings = async (query: any) => {
    try {
        const result = await unifiedApi.get('/api/v1/ratings', {
            params: query
        });

        return {
            success: true,
            data: result.data.data,
            pager: result.data.pager
        };
    } catch (error: any) {
        return {
            success: false,
            message: "An unexpected Error"
        };
    }
}


const getInsights = async () => {
    try {
        const result = await unifiedApi.get('/api/v1/ratings-insights', {

        });

        return {
            success: true,
            data: result.data.data,
            pager: result.data.pager
        };
    } catch (error: any) {
        return {
            success: false,
            message: "An unexpected Error"
        };
    }
}


export default {
    getRatings,
    getInsights
}